<template>
  <router-view />
</template>

<script>
export default {
  name: 'Gmb',
}
</script>
